import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

export default function ListDialog(props) {
  const [data, setData] = useState([]);

  function handleInput(event) {
    setData(event.target.value.split(/\n/));
  }

  return (
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        scroll={props.scroll}
        fullWidth
        maxWidth="md"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Add Recipients</DialogTitle>
        <DialogContent dividers={props.scroll === 'paper'}>
          <TextField
            id="outlined-multiline-static"
            label="Multiline"
            multiline
            fullWidth
            rows={30}
            rowsMax={40}
            onChange={handleInput}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => props.handleAdd(data)}
            color="primary"
            disabled={(data.length === 0)}
          >
            Add to DB
          </Button>
          <Button onClick={props.handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
}

ListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  scroll: PropTypes.string.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
